// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-8526edea] .dialog {\n  width: 900px !important;\n}\n[data-v-8526edea] .el-dialog {\n  margin-top: 1vh !important;\n}", ""]);
// Exports
module.exports = exports;
